import { render, staticRenderFns } from "./LogisticsDesc.vue?vue&type=template&id=260adc7b&scoped=true&"
var script = {}
import style0 from "./LogisticsDesc.vue?vue&type=style&index=0&id=260adc7b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260adc7b",
  null
  
)

export default component.exports